import styled from 'styled-components';
import theme from 'styled-theming';
import {
  Popover as ShellPopover,
  Drawer as ShellDrawer,
} from '@sede-enterprise/shell-ds-react-framework';

const tabColor = theme('name', {
  light: '#757575',
  dark: 'rgba(255, 255, 255, 0.57)',
});

const activeTabColor = theme('name', {
  light: '#404040',
  dark: '#FFFFFF',
});

const layoutBackgroundColor = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#1C1C1C',
});

export const pectenAreaBgColor = theme('name', {
  light: 'rgba(255, 255, 255, 0.1)',
  dark: 'rgba(0, 0, 0, 0.05)',
});

export const LayoutContainer = styled.div`
  position: relative;
  font-family: 'system-ui', sans-serif;
  background-color: ${layoutBackgroundColor};
  color: ${(prop) => prop.color};
  min-height: 100vh;

  .shell-tabs .shell-tabs-tab,
  .shell-menu-label {
    color: ${tabColor} !important;
  }

  .shell-tabs .shell-tabs-tab-active,
  .shell-menu-item-selected > .shell-menu-label {
    color: ${activeTabColor} !important;
  }

  .shell-tabs .shell-tabs-tab-active .shell-tabs-tab-btn,
  .shell-tabs .shell-tabs-tab-active .shell-tabs-tab-btn span {
    font-weight: 600;
  }

  div:has(.shell-nav-bar) {
    height: 72px;
    .shell-nav-bar {
      padding: unset;
      gap: 5px;
    }

    .shell-menu-item {
      padding: 25px 10px;
      font-size: 14px;
      font-weight: 600;
    }

    .shell-menu-label {
      display: flex;
      flex-direction: row-reverse;
      gap: 2px;
      .count {
        min-width: 15px;
        min-height: 15px;
        span {
          font-size: 10px;
        }
      }
    }

    .shell-menu-horizontal .shell-menu-item.shell-menu-item-selected {
      background: unset;
      ::after {
        height: 4px;
        bottom: unset;
        top: 0;
      }
    }
  }

  .shell-tabs .shell-tabs-tab-btn:focus {
    border: unset;
  }

  .uk-cap-pending-count,
  .maunal-cap-pending-count,
  .pending-count {
    background-color: rgb(217, 54, 56);
    color: white;
    height: 22px;
    width: auto;
    border-radius: 10px;
    text-align: center;
    margin-left: 3px;
    padding: 1px 5px;
    font-size: 10px;
    line-height: 10px;
  }

  div:has(.shell-menu-horizontal) {
    width: 100%;
  }
  .shell-menu-horizontal {
    width: 100%;
  }
  .notification-count {
    position: absolute;
    top: -4px;
    left: 14px;
  }
`;

export const MidSection = styled.section`
  display: flex;
  flex: 0;
  height: calc(100vh - 72px);
  position: relative;
  overflow: hidden;
`;

export const ContentContainer = styled.section`
  flex: 1;
  box-sizing: border-box;
  transition: margin-left 0.5s;
  width: 100%;
`;

export const Popover = styled(ShellPopover)`
  z-index: 30;
  .content {
    padding: 20px 15px;
  }
  .gas-day {
    margin: 10px 0;
  }
  .loading {
    display: flex;
    gap: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .button_wrapper {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 30px;
  }
`;

export const HeaderIconWrapper = styled.div`
  svg {
    height: 27px;
    width: 27px;
    margin-top: 4px;
  }
`;

export const NotificationDrawer = styled(ShellDrawer)`
  z-index: 50;
  .shell-drawer-content {
    scrollbar-width: thin;
  }
  .shell-drawer-content > div {
    padding: 0 20px !important;
  }
`;

export const NavBarSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right-section {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-right: 24px;
    .gemini-button {
      svg {
        width: 27px;
        height: 27px;
        margin-top: 4px;
      }
    }
    .theme-button {
      svg {
        width: 24px;
        height: 24px;
      }
    }
    .notifications-button {
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
`;

export const GenesisHeader = styled.div<{ flexdirection: string }>`
  display: flex;
  flex-direction: ${(props) => props.flexdirection};
`;

export const PectenWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${pectenAreaBgColor};

    .home-icon {
      transition: transform 0.2s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`;
